import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getDecisionNodeAtPath } from '../../../../../../extractFromState';
import { ExpertQuestionSection, Title } from '../../DTQuestionOrInstruction.styles';
import { getSelectedLineItems } from '../../../../../../selectors/tools';
import DTImageGridGallery from '../../../../Common/DTImageGridGallery/DTImageGridGallery';
import DTQuestionOrInstructionView from '../../DTQuestionOrInstructionView';
import ButtonList from '../../Common/ButtonList/ButtonList';
import Question from '../../Common/Question/Question';
import { GalleryWrapper } from './DTShowImagesOfSelectedItemsNode.styles';

const DTShowImagesOfSelectedItemsNode = () => {
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const selectedLineItems = useSelector(getSelectedLineItems);

  const renderQuestion = () => (
    <ExpertQuestionSection>
      <Question />
      <GalleryWrapper>
        <DTImageGridGallery imageObjects={imageObjects} />
      </GalleryWrapper>
      {decisionNode?.subText2 && <Title>{decisionNode?.subText2}</Title>}
    </ExpertQuestionSection>
  );

  const imageObjects = useMemo(
    () =>
      selectedLineItems.map((item) => ({
        src: item.productImageUrl,
        fileName: item.itemName,
      })),
    [selectedLineItems]
  );

  return (
    <DTQuestionOrInstructionView
      titleSection={renderQuestion()}
      options={<ButtonList isButtonDisabled={false} />}
      loading={false}
      fullWidth={true}
    />
  );
};

export default DTShowImagesOfSelectedItemsNode;
